module.exports = __webpack_public_path__ + "static/seres-silk-duvet-1-thumbnail-bb1ff844d3dd17c53251e7e0654d2c37.webp";